import React from 'react';
import { TextInput, TextInputProps } from '@lightbeamhealth/blueprint-form';

const Input: React.FC<TextInputProps> = ({ className, ...props }) => {
  return <TextInput className={className} {...props} />;
};

export default Input;
